import { render, staticRenderFns } from "./FaqHtmlPage.vue?vue&type=template&id=22a47a5d&scoped=true"
import script from "./FaqHtmlPage.vue?vue&type=script&lang=js"
export * from "./FaqHtmlPage.vue?vue&type=script&lang=js"
import style0 from "./FaqHtmlPage.vue?vue&type=style&index=0&id=22a47a5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a47a5d",
  null
  
)

export default component.exports